export default __webpack_public_path__ + "static/media/logo-removebg-preview.a110719e.png";